import styled from 'styled-components'

const OptionButtonWrapperStyled = styled.div``
export default OptionButtonWrapperStyled
